export const CONTENT_TYPE = {
  JSON: "application/json",
  URL_ENCODED: "application/x-www-form-urlencoded",
  FORM_DATA: "multipart/form-data"
};
